<!--
 * @Author: chenyingxuan chenyingxuan@abc.com
 * @Date: 2024-01-08 11:13:36
 * @LastEditors: chenyingxuan chenyingxuan@abc.com
 * @LastEditTime: 2024-01-09 14:21:48
 * @FilePath: /platform/src/views/form/billingCenter/billingCenterAdmin.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="height: calc(100% - 20px);padding-top: 16px">
    <div id="accountManagement" class="fullheight">
      <eco-table
        @load="loadData"
        :data="budget_manager"
        :pageResult="pageResult"
        :selection="true"
        :quick-search-props="[{ prop: 'name', label: '租户名称' }]"
        :show-export="false"
        :show-custom-column="false"
        ref="ecoTable"
      >
        <template>
          <eco-table-column type="index" width="50" align="center" label="序号" />
          <eco-table-column prop="tenantName" label="租户名称" :sortable="true" sort-by="name" :show-overflow-tooltip="true">
            <template v-slot="{ row }">
              <el-link type="primary" :underline="false" @click="edit(row)">{{ row.tenantName }}</el-link>
            </template>
          </eco-table-column>
          <eco-table-column prop="tenantType" label="租户类型" :sortable="true" sort-by="typeName" :show-overflow-tooltip="true"> </eco-table-column>
          <eco-table-column prop="tenantStatus" label="租户状态" :sortable="true" :show-overflow-tooltip="true"> </eco-table-column>
          <eco-table-column prop="openModules" label="订阅模块" :sortable="false" :show-overflow-tooltip="true"> </eco-table-column>
          <eco-table-column prop="dueModules" label="欠费模块" :sortable="false" :show-overflow-tooltip="true"> </eco-table-column>
          <eco-table-column prop="expireTime" label="模块到期时间" :sortable="false" :show-overflow-tooltip="true"> </eco-table-column>
          <eco-table-column width="180" label="操作">
            <template v-slot="{ row }">
              <el-link type="primary" :underline="false" @click="edit(row)"> 编辑</el-link>
            </template>
          </eco-table-column>
        </template>
      </eco-table>
    </div>
  </div>
</template>

<script>
import req from '@/request'
export default {
  data() {
    return {
      budget_manager: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      }
    }
  },
  methods: {
    edit(row) {
      this.$router.push({
        path: '/billingCenterCommon',
        query: {
          code: row.code,
          id: row.tenantId,
          name: row.tenantName,
          status: row.status
        }
      })
    },
    loadData(param, cb) {
      if (param && cb) {
        const obj = {
          param: param,
          cb: cb
        }
        sessionStorage.setItem('loadJSON', JSON.stringify(obj))
      }
      if (!param) {
        const session = JSON.parse(sessionStorage.getItem('loadJSON'))
        param = session.param
        cb = session.cb
      }

      let url = window.context.third + '/system/account_mangement/query'
      req
        .post(url, param)
        .then((res) => {
          let response = res.data.rows
          if (response.length > 0) {
            // response.forEach(item => {
            // item.tenantName = item.tenantName;
            // item.tenantType = item.tenantType;
            // item.tenantStatus = item.tenantStatus;
            // item.openModules = item.openModules;
            // item.dueModules = item.dueModules;
            // item.expireTime = item.expireTime;
            // });
          }
          this.budget_manager = response
        })
        .finally(() => cb())
    }
  }
}
</script>
